<template>
    <div class="wlx-site-manager-wrapper wlx-user-manager">
        <header class="site-manager-head-con" style="padding-top: 20px">
            <span style="font-weight: 600; float: left; margin-left: 30px; font-size: 16px">项目:{{ projectName }}</span>
            <el-button type="primary" icon="wl-icon-fanhui" @click="fanhui">返回</el-button>
        </header>
        <header class="site-manager-head-con" style="padding-top: 20px">
            <el-form :inline="true" size="small">
                <el-form-item>
                    <el-input v-model="searchName" placeholder="请输入关键字" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getProjectAppLyList()">搜索</el-button>
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addInfo">新增</el-button>
                    <el-button type="primary" @click="ImportDialogVisible = true" v-if="wordUrl">导入</el-button>
                    <el-button type="danger" icon="el-icon-delete" @click="deleteAll">删除</el-button>
                    <a class="export-button-a" style="color: #fff; margin-left: 10px" :href="exportExam">导出</a>
                    <!-- <el-button type="primary" icon="el-icon-delete" @click="DeleteAllDialogVisible = true">删除</el-button> -->
                </el-form-item>
            </el-form>
        </header>
        <div style="padding-left: 30px">
            <el-table :data="list" ref="multipleeeeTable" @selection-change="handleSelectionChange" :row-key="getRowKeys">
                <el-table-column prop="id" type="selection" :reserve-selection="true" width="55"></el-table-column>
                <el-table-column label="序号" type="index"></el-table-column>
                <el-table-column :prop="item" :label="item" v-for="(item, index) in fieIdNames" :key="index">
                    <template slot-scope="scope">
                        <span v-if="scope.row.fieldList.length>0">{{ scope.row.fieldList[index].fielValue }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createUserName" label="创建人账号"></el-table-column>
                <el-table-column prop="createDisplayName" label="创建人"></el-table-column>
                <el-table-column prop="dateCreated" label="创建日期"></el-table-column>
                <el-table-column label="操作" width="300px">
                    <template slot-scope="scope">

                        <el-button size="mini" type="primary" @click="downloadFile(scope.row)">导出附件</el-button>
                        <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button size="mini" type="danger" @click="deleteInfo(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-page-con">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="onPageChangeHandler"
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    v-show="totalCount > 0"
                    style="text-align: center"
                ></el-pagination>
            </div>
        </div>

        <el-dialog :title="titleFormVisible" :visible.sync="dialogFormVisible" :append-to-body="true" width="800px">
            <form-create v-model="fApi" :rule="rule" :option="option" @submit="editInfo"></form-create>
            
            <el-form :inline="true" :model="form" class="demo-form-inline" label-width="120px" v-if="isUploadFile==1 && dialogFormVisible">
                <el-form-item label="附件上传" prop="filebIds">
                    <applyFileUpload
                        :url="urlAliyunOSS"
                        :files="files"
                        :fileLists="files"
                        :IsMultiple="true"
                        @done="onAllFilesUploadb"
                        class="apply-file-upload"
                    ></applyFileUpload>
                </el-form-item>
            </el-form>
             <div slot="footer" class="dialog-footer">
                <el-button @click="cancelInfo">取 消</el-button>
                <el-button type="primary" @click="editInfo()">确 定</el-button>
            </div>
        </el-dialog>


         <el-dialog title="下载附件" :visible.sync="dialogDownloadVisible" :append-to-body="true" width="800px">
            <div v-for="(item, index) in files" :key="index" style="padding:30px"> 
              <span>{{item.name}}</span>  <a :href="item.downloadUrl" target="_blank" style="margin-left:10px">下载</a>
            </div>
        </el-dialog>

        <!-- 导入考生成绩 -->
        <el-dialog title="Excel批量导入证书信息" :close-on-click-modal="false" :visible.sync="ImportDialogVisible" width="740px" class="import-stu-info-dialog" :append-to-body="true">
            <div class="tip-info-main">
                <div class="top-tip-con">
                    <div class="clearfix">
                        <span class="fl">操作提示：</span>
                        <div class="fl tip-article-con">
                            为了方便您的工作，我们已经准备好了《信息导入模板》的标准模版，请您先下载考生证书导入标准模版，填写后选择填写好的模版导入数据即可，
                            <span class="mark-tip"> 为了能够准确的导入数据，请务必按照标准模版的要求进行填写。 </span>
                        </div>
                    </div>
                    <div class="download-model-con">
                        <a :href="wordUrl" class="el-link">
                            <el-button type="primary" class="download-model-btn">下载信息导入模板</el-button>
                        </a>
                    </div>
                </div>
                <div class="import-table-con">
                    <p><i class="kz-icon-tishi"></i> 请选择要导入的信息表格</p>
                    <el-upload class="upload-demo" ref="upload" :action="uploadUrl" :file-list="fileList" :auto-upload="false" :on-success="onSuccess" accept="xls" :limit="1" style="display: inline-block; text-align: center; margin-top: 15px">
                        <el-button slot="trigger" type="primary">选择导入文件</el-button>
                        <div slot="tip" class="el-upload__tip"></div>
                    </el-upload>
                    <!-- <el-button type="primary" class="select-impoort-file">选择导入文件</el-button> -->
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="ImportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="importFile">确定导入</el-button>
            </span>
        </el-dialog>
        <!-- 进度条 -->
        <el-dialog title="数据导入中。。。" :close-on-click-modal="true" :visible.sync="percentageVisible" width="740px" class="import-stu-info-dialog" :append-to-body="true">
            <div class="tip-info-main">
                <div class="import-table-con">
                    <el-progress :text-inside="true" :stroke-width="26" :percentage="percentage"></el-progress>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelImport">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 数据导入结果 -->
        <el-dialog title="数据导入结果" :visible.sync="dataResultVisible" width="740px" class="import-stu-info-dialog" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false">
            <div class="tip-info-main">
                <div class="import-table-con">
                    <p><i class="kz-icon-tishi"></i> 您本次共导入{{ count }}条数据，导入结果如下</p>
                    <div>
                        <div class="clearfix down-load-btn">
                            <span class="fl sp-import-num">导入成功：{{ successNum }}条</span>
                            <a v-if="successNum > 0" :href="successUploadFileUrl">
                                <el-button type="primary" class="fr">下载导入成功记录</el-button>
                            </a>
                        </div>
                        <div class="clearfix down-load-btn">
                            <span class="fl sp-import-num">导入失败：{{ failNum }}条</span>
                            <a v-if="failNum > 0" :href="failUploadFileUrl">
                                <el-button type="primary" class="fr download-model-btn">下载导入失败记录</el-button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dataResultVisible = false">取 消</el-button>
                <el-button type="primary" @click="dataResultVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 批量删除 -->
        <el-dialog :before-close="cancel" title="批量删除" :visible.sync="DeleteAllDialogVisible" width="30%" top="3%" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false">
            <el-form ref="form" label-width="120px" size="mini">
                <el-form-item label="开始时间">
                    <el-date-picker v-model="deleteStartTime" type="datetime" placeholder="选择开始时间"> </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间">
                    <el-date-picker v-model="deleteEndTime" type="datetime" placeholder="选择结束时间"> </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelDeleteAll">取 消</el-button>
                <el-button type="primary" @click="deleteAll()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
import applyFileUpload from "components/uploads/muUploadEnclosure.vue";
export default {
    data() {
        return {
            fApi: null,
            rule: [],
            ruleJson:[],
            option: {},
            optionJson: {},
            page: 1,
            pageSize: 10,
            totalCount: 0,
            searchName: "",
            idCard: "",
            certificateNumber: "",
            certificateType: "",
            certificateBatchId: "",
            searchAuditStatus: "",
            isUploadFile:0,
            fieIdNames: [],
            list: [],
            form: {
                id:"",
                filebIds: "",
                formFieldsJson:[],
                formRuleJson:[]
            },
            files: [],
            urlAliyunOSS: "/api/XOrg/AssociationIndex/getSign",
            //编辑信息
            titleFormVisible: "",
            dialogFormVisible: false,
            //导入
            ImportDialogVisible: false,
            // uploadUrl: "/api/XOrg/ProjectAppLy/uploadExcelPro",
            fileList: [], //导入文件
            errorList: [], //错误信息
            certTypeList: [],
            certGradeList: [],
            certTypeId: "",
            batchList: [],
            searCertGradeList: [],
            // 导入结果
            inportcertificateBatchId: "",
            dataResultVisible: false,
            dialogDownloadVisible :false,

            wordUrl: "",
            count: 0,
            successNum: 0,
            successFileName: "",
            failNum: 0,
            failFileName: "",
            // 批量删除
            DeleteAllDialogVisible: false,
            deleteStartTime: "",
            deleteEndTime: "",
            //
            percentageVisible: false,
            percentage: 0,
            taskId: "",
            timer: null,
            ids: [],
            importRule: {
                inportcertificateBatchId: [{ required: true, message: "请选择证书批次", trigger: "blur" }],
            },
            // 获取row的key值
            getRowKeys(row) {
                return row.id;
            },
            projectName: "",
        };
    },
    components: {
        imageUpload,
        applyFileUpload
    },
    props: {
        projectId: {
            type: String,
            default: "",
        },
    },
    computed: {
        uploadUrl() {
            return decodeURI("/api/XOrg/ProjectAppLy/uploadExcelPro?projectId=" + this.projectId);
        },
        failUploadFileUrl() {
            return decodeURI("/api/XOrg/ImportTask/uploadImportFile?id=" + this.taskId + "&type=2");
        },
        successUploadFileUrl() {
            return decodeURI("/api/XOrg/ImportTask/uploadImportFile?id=" + this.taskId + "&type=1");
        },
        exportExam: function () {
            return "/api/XOrg/ProjectAppLy/exportExcel?searchName=" + this.searchName + "&projectId=" + this.projectId;
        },
    },
    created() {
        this.getProjectAppLyList();
        this.getFieIdNames();
    },
    watch: {},
    methods: {
        onAllFilesUploadb(files) {
            this.form.filebIds = [];
            this.form.filebIds = files;
        },
        handleSelectionChange(val) {
            var that = this;
            this.ids = [];
            val.forEach((element) => {
                that.ids.push(element.id);
            });
        },
        //删除
        deleteAll() {
            var that = this;
            this.$confirm("此操作将删除所选数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                that.$http
                    .post("/api/XOrg/ProjectAppLy/deleteSysProjectApply", {
                        ids: this.ids,
                    })
                    .then(function (rst) {
                        if (rst.code > 0) {
                            that.$message.success(rst.msg);
                            that.getProjectAppLyList();
                        } else {
                            that.$message.warning(rst.msg);
                        }
                    });
            });
        },
        // 取消进度条
        cancelImport() {
            var that = this;
            that.$http
                .post("/api/XOrg/ImportTask/cancelImport", {
                    id: that.taskId,
                })
                .then(function () {
                    that.percentageVisible = false;
                    clearInterval(that.timer);
                });
        },
        cancelDeleteAll() {
            this.DeleteAllDialogVisible = false;
            this.deleteStartTime = "";
            this.deleteEndTime = "";
        },
        cancelInfo() {
            this.form.id = "";
            this.form.formFieldsJson = [];
            this.form.formRuleJson = [];
            this.files = [];
            this.form.filebIds = [];
            this.dialogFormVisible = false;
        },
        onSuccess(res) {
            var that = this;
            if (res.code > 0) {
                this.ImportDialogVisible = false;
                this.percentageVisible = true;
                this.taskId = res.taskId;
                this.timer = setInterval(function () {
                    that.$http
                        .post("/api/XOrg/ImportTask/getImportProgress", {
                            id: res.taskId,
                        })
                        .then(function (rst) {
                            if (rst.code > 0) {
                                that.percentage = rst.info.progressBar;
                                if (that.percentage == 100) {
                                    clearInterval(that.timer);
                                    that.failNum = rst.info.failNumber;
                                    that.successNum = rst.info.successNumber;
                                    that.count = rst.info.importCount;
                                    that.dataResultVisible = true;
                                    that.percentageVisible = false;
                                    that.percentage = 0;
                                    that.page = 1;
                                    that.cancel();
                                    that.getProjectAppLyList();
                                }
                            } else {
                                that.$message.warning(rst.msg);
                            }
                        });
                }, 2000);
            } else {
                this.$message.warning(res.msg);
            }
        },
        //导入题库
        importFile() {
            this.$refs.upload.submit();
        },
        //清除数据
        cancel() {
            this.ImportDialogVisible = false;
            // this.inportcertificateBatchId = "";
            this.inportcertificateBatchId = this.projectId;
            this.fileList = [];
        },
        addInfo() {
            this.rule = JSON.parse( JSON.stringify(this.ruleJson));
            this.option.submitBtn = false
            this.titleFormVisible = "新增";
            this.dialogFormVisible = true;
        },
        //编辑
        editInfo() {
            var that = this;
            const r = this.fApi.rule;
            console.log(JSON.stringify(r));
            this.$http
                .post("/api/XOrg/ProjectAppLy/addOrEditProjectAppLy", {
                    id: this.form.id,
                    projectId: this.projectId,
                    jsonStr: JSON.stringify(r),
                    ruleJson: JSON.stringify(this.optionJson),
                    files: JSON.stringify(this.form.filebIds)
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.$message.success(rst.msg);
                        that.cancelInfo();
                        that.getProjectAppLyList();
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },

        downloadFile(row){
            this.dialogDownloadVisible=true;
           this.files = row.fileList;
        },

        //弹出框赋值
        handleEdit(row) {
            this.form.id = row.id;
            this.rule = JSON.parse(row.formFieldsJson);
            this.rule.forEach(element => {
                if(element.validate == null){
                    element.validate = [];
                }
                if(element.props == null){
                    element.props = {};
                }
            });
            console.log(this.rule);
            this.option = JSON.parse(row.formRuleJson);
            this.option.submitBtn = false;
            this.form.filebIds = [];
            row.fileList.forEach(ele => {
                this.form.filebIds.push({
                    docId: ele.id,
                    docTitle:ele.name
                });
            });
            this.files = row.fileList;
            this.titleFormVisible = "编辑";
            this.dialogFormVisible = true;
        },
        //删除
        deleteInfo(id) {
            var that = this;
            this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                that.$http
                    .post("/api/XOrg/ProjectAppLy/deleteSysProjectApply", {
                        ids: id,
                    })
                    .then(function (rst) {
                        if (rst.code > 0) {
                            that.$message.success(rst.msg);
                            that.getProjectAppLyList();
                        } else {
                            that.$message.warning(rst.msg);
                        }
                    });
            });
        },
        getFieIdNames() {
            var that = this;
            this.$http
                .post("/api/XOrg/ProjectAppLy/getFieIdNames", {
                    projectId: this.projectId,
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.wordUrl = rst.projectInfo.docUrl;
                        that.projectName = rst.projectInfo.projectName;
                        that.fieIdNames = rst.fieIdNames;
                        that.ruleJson = JSON.parse(rst.projectInfo.formFieldsJson);
                        that.rule = JSON.parse(rst.projectInfo.formFieldsJson);
                        that.option = JSON.parse(rst.projectInfo.formRuleJson);
                        that.optionJson = JSON.parse(rst.projectInfo.formRuleJson);
                        that.isUploadFile = rst.projectInfo.isUploadFile;
                        console.log(that.rule);
                        console.log(that.option);
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        //查询
        getProjectAppLyList() {
            var that = this;
            this.$http
                .post("/api/XOrg/ProjectAppLy/getProjectAppLyList", {
                    searchName: this.searchName,
                    projectId: this.projectId,
                    PageSize: that.pageSize,
                    page: that.page,
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.list = rst.list;
                        that.page = rst.pagination.pageIndex;
                        that.pageSize = rst.pagination.pageSize;
                        that.totalCount = rst.pagination.totalCount;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getProjectAppLyList();
        },
        onPageChangeHandler(val) {
            this.page = val;
            this.getProjectAppLyList();
        },
        onSubmit(formData) {
            
        },
        fanhui() {
            this.$router.push({
                name: "projectManager",
            });
        },
    },
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper {
    .demo-form-inline {
        .el-input__inner {
            width: 200px;
        }

        .img_upload {
            width: 500px;
        }
    }
    .export-button-a {
        padding: 9px 15px;
        background-color: #409eff;
        font-size: 12px;
        border-radius: 3px;
    }
}

.import-stu-info-dialog {
    .el-dialog__header {
        background: #2f7dff;

        .el-dialog__title {
            color: #fff;
        }

        .el-dialog__headerbtn,
        .el-icon-close {
            color: #fff;
        }
    }

    .tip-info-main {
        margin: 20px 30px;
        color: #1a2638;
    }

    .top-tip-con {
        padding-bottom: 25px;
        border-bottom: 1px solid #d8e0e6;
    }

    .tip-article-con {
        margin-left: 10px;
        width: 550px;
        line-height: 1.5;

        .mark-tip {
            color: #e65b72;
        }
    }

    .download-model-con {
        margin-top: 29px;
        text-align: center;
    }

    .download-model-btn {
        background: #ee6c3a;
        border-color: #ee6c3a;
    }

    .import-table-con {
        padding-top: 20px;
        text-align: center;
    }

    .down-load-btn {
        margin-top: 25px;
    }

    .sp-import-num {
        margin-top: 6px;
    }

    .select-impoort-file {
        margin-top: 20px;
    }
}
</style>
